module.exports = __webpack_public_path__ + "static/media/projectYou.9b63f014.jpg";